module.exports = __webpack_public_path__ + "static/media/companyIcon.644bb2fb.svg";